import config from "@/config";
import { useAxios } from "@vueuse/integrations/useAxios";
import axios from "axios";

export default function useSettingsApiClient() {
  const client = axios.create({
    baseURL: config.settingsApiBaseUrl,
  });

  return {
    useAxios,
    client,
  };
}
